
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/object-overview",
      function () {
        return require("private-next-pages/object-overview.tsx");
      }
    ]);
  